<template>
  <page-list
    :showGroupActions="false"
    :showSearchbox="false"
    :list="list"
    :columns="columns"
    :single-actions="singleActions" />
</template>

<script>
import { getNameDescriptionTableColumn, getEnabledTableColumn } from '@/utils/common/tableColumn'
import ListMixin from '@/mixins/list'

export default {
  name: 'GuideHostList',
  mixins: [ListMixin],
  inject: ['currentItem'],
  data () {
    return {
      list: this.$list.createList(this, {
        resource: 'hosts',
        getParams: {
          brand: this.currentItem.provider,
        },
        filterOptions: {
          name: {
            label: this.$t('scope.text_21'),
            filter: true,
            formatter: val => {
              return `name.contains("${val}")`
            },
          },
        },
        responseData: this.responseData,
      }),
    }
  },
  computed: {
    columns () {
      return [
        {
          field: 'zone',
          title: this.$t('scope.text_22'),
        },
        // {
        //   field: 'zone',
        //   title: '二层网络',
        // },
        getNameDescriptionTableColumn({
          onManager: this.onManager,
          showDesc: false,
        }),
        {
          field: 'custom_ip',
          title: 'IP',
          showOverflow: 'ellipsis',
          slots: {
            default: ({ row }) => {
              const cellWrap = []
              if (row.access_ip) {
                cellWrap.push(
                  <div class="d-flex">
                  管理IP：<list-body-cell-wrap row={row} field="access_ip" copy />
                  </div>,
                )
              }
              if (row.ipmi_ip) {
                cellWrap.push(
                  <div class="d-flex">
                    带外IP：<list-body-cell-wrap row={row} field="ipmi_ip" copy />
                  </div>,
                )
              }
              return cellWrap
            },
          },
        },
        getEnabledTableColumn(),
      ]
    },
    singleActions () {
      return [
        {
          label: this.$t('scope.text_19'),
          action: (obj) => {
            this.list.singlePerformAction('enable', {
              id: obj.id,
            })
          },
          meta: (obj) => {
            return {
              validate: !obj.enabled,
            }
          },
        },
        {
          label: this.$t('scope.text_20'),
          action: (obj) => {
            this.list.singlePerformAction('disable', {
              id: obj.id,
            })
          },
          meta: (obj) => {
            return {
              validate: obj.enabled,
            }
          },
        },
      ]
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    doSubmit () {
      let flag = false
      const { data } = this.list
      for (const k in data) {
        const item = data[k].data
        if (item.enabled) {
          flag = true
        }
      }
      if (!flag) {
        this.$message.warning(this.$t('scope.text_23'))
        return false
      }
      return true
    },
  },
}
</script>
